document.addEventListener('DOMContentLoaded', function () {
  function initConsenticoAccordion() {
    const panels = document.querySelectorAll(
      '.egl-pdp_panel.egl-pdp_prominent'
    );

    panels.forEach(function (panel) {
      if (panel.dataset.accordionReady === 'true') return;

      panel.dataset.accordionReady = 'true';

      panel.addEventListener('click', function () {
        panel.classList.toggle('is-open');
      });
    });
  }

  initConsenticoAccordion();

  // Falls Consentico das Widget nachträglich lädt
  const observer = new MutationObserver(function () {
    initConsenticoAccordion();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});